module.exports = __webpack_public_path__ + "static/media/user-orange.6cef2754.svg";